<template>
    <div>
        <h2>SHPO Annual Report</h2>
        <div class="container">
            <form @submit.prevent="" class="form-horizontal">
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="searchFieldOrgName">Report Date Range</label>
                    </div>
                    <div class="col-sm-2">
                        <el-date-picker v-model="searchDto.startDate" type="date" format="MM/dd/yyyy" placeholder="Start Date"></el-date-picker>
                    </div>
                    <div class="col-sm-2">
                        <el-date-picker v-model="searchDto.endDate" type="date" format="MM/dd/yyyy" placeholder="End Date"></el-date-picker>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="searchAgencyName">Agency Name</label>
                    </div>
                    <div class="col-sm-5">
                    <select name="searchAgencyName" class="form-control" v-model="searchDto.agencyId">
                        <option :value="null">All</option>
                        <option v-for="organization in leadAgencyList" :key="organization.description" :value="organization.id">{{ organization.description}}</option>
                    </select>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-2">
                        <button class="btn btn-primary" type="submit" name="button" v-on:click="runReport">Run Report</button>
                    </div>
                </div>
            </form>
        </div>
        <div class="wrapper" v-if="reportDto">
            <div  class="row row-wider">
                <div class="col-md-12">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Field</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="prop in Object.keys(reportDto)" :key="prop">
                                <!-- v-show="!['startDate', 'endDate', 'agencyDescription'].includes(prop)"> -->
                                <td>
                                    {{prop}}
                                </td>
                                <td>
                                    {{reportDto[prop]}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-2">
                <button class="btn btn-primary" type="submit" name="button" v-on:click="exportCsv">Export to CSV</button>
            </div>
            <div class="col-md-3">
                <button class="btn btn-primary" type="submit" name="button" v-on:click="exportPrehistoricSnrCsv">Export Prehistoric SNR CSV</button>
            </div>
        </div>
    </div>
</template>
<script>
    import loggingService from '@/services/util/loggingService'
    import organizationService from '@/services/organizationService'
    import reportService from '@/services/reportService'
    import mediaService from '@/services/mediaService'
    import loader from '@/components/Loader.vue'

    export default {
        components: {
            loader
        },
        data: function () {
            return {
                isDebug: false,
                searchDto: {
                    startDate: null,
                    endDate: null,
                    agencyId: null
                },
                leadAgencyList: [],
                reportDto: null
            }
        },
        computed: {
        },
        mounted () {
            loggingService.log(this.isDebug, 'SHPO Annual Report', 'mounted')
            this.loadLeadAgencyList()
        },
        methods: {
            loadLeadAgencyList () {
                this.leadAgencyList = []
                return organizationService.listLeadAgencyLookup(this.$http).then(response => {
                    this.leadAgencyList = response.data
                })
            },
            runReport () {
                reportService.shpoAnnualReportData(this.$http, this.searchDto).then(response => {
                    console.log(this.searchDto)
                    this.reportDto = response.data
                })
            },
            exportCsv () {
                reportService.shpoAnnualReportDataCsv(this.$http, this.searchDto).then(response => {
                    mediaService.saveFileToDownload(response, 'shpoannualreport.csv')
                })
            },
            exportPrehistoricSnrCsv () {
                reportService.shpoPrehistoricSnrReportDataCsv(this.$http, this.searchDto).then(response => {
                    mediaService.saveFileToDownload(response, 'shpoprehistoricsnrreport.csv')
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// ShpoAnnualReport.vue?36e3e27e